import React, { useState } from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useBroadcast } from '../../Data/Broadcasts';
import { useParams } from 'react-router-dom';
import { PageLoading } from '../../Components/Loading';
import Tabs, { Tab } from '../../Components/Containers/Tabs/Tabs';
import Details from './Details';
import Customers from './Customers';
import Template from './Template';
import { usePreference } from '../../Data/Preference';
import AddEditBroadcast from '../Broadcasts/AddEditBroadcast';
import { ulid } from 'ulid';
import { useDialogues } from '../../Components/Dialogues';
import { getEntityLink, useRedirect } from '../../Services/helpers';

const Broadcast = () => {
    const {broadcastId} = useParams();
    const {broadcast, selectRecipients, removeRecipients, send, update, duplicate, archive} = useBroadcast(broadcastId, true);
    const [isUpdating, setIsUpdating] = useState(false);
    const {confirm} = useDialogues();
    const {go, Redirect} = useRedirect();

    return <>
        <TopBar left="/more/broadcasts"
            title={broadcast ? broadcast.title : 'Broadcast'}
            dropdownOptions={[
                {
                    title: 'Update broadcast',
                    icon: 'Pencil',
                    onClick: () => setIsUpdating(true),
                    disabled: !(broadcast?.preSend ?? false),
                },
                {
                    div: true,
                },
                {
                    title: 'Copy broadcast',
                    icon: 'Copy',
                    onClick: () => confirm(
                        {
                            theme: 'primary',
                            icon: 'Copy',
                            title: 'Copy broadcast',
                            confirmLabel: 'Copy',
                            message: `Are you sure you want to make a copy of this broadcast?\nYou can make changes before it's sent.`,
                        },
                        async () => {
                            const duplicateId = ulid();
                            await duplicate(duplicateId);
                            go(getEntityLink('Broadcasts/Broadcast', duplicateId));
                        }
                    ),
                },
                {
                    div: true,
                },
                {
                    title: 'Archive broadcast',
                    icon: 'Trash',
                    onClick: () => confirm(
                        {
                            theme: 'danger',
                            icon: 'Trash',
                            title: 'Delete broadcast',
                            confirmLabel: 'Delete',
                            message: `Are you sure you want to archive the broadcast "${broadcast.title}"? You can't undo this.`,
                        },
                        () => archive().then(() => go('/more/broadcasts'))
                    ),
                    disabled: broadcast?.status === 'Sending',
                },
            ]}
        />
        <Page>
            {broadcast ? <Inner {...{broadcast, selectRecipients, removeRecipients, send}} /> : <PageLoading />}
        </Page>

        <AddEditBroadcast isOpen={isUpdating}
            setIsOpen={setIsUpdating}
            broadcast={broadcast}
            save={update}
        />

        <Redirect />
    </>
}

const Inner = ({broadcast, selectRecipients, removeRecipients, send}) => {
    const [tab, setTab] = usePreference('broadcastTab', 'Details');

    return <Tabs selected={tab} onChange={setTab}>
        <Tab title="Details">
            <Details {...{broadcast, send}} />
        </Tab>
        <Tab title="Customers">
            <Customers {...{broadcast, selectRecipients, removeRecipients}} />
        </Tab>
        <Tab title="Template">
            <Template {...{broadcast}} />
        </Tab>
    </Tabs>
}

export default Broadcast;